// extracted by mini-css-extract-plugin
export default {"actions":"whMZ0Th1YWNX39yxVz3P"};